<template lang="pug">
app-page(:fabItems="fabItems" title="История дел" :loading="loading"  @search="text => (search = text.toLowerCase())")
  app-toolbar(:title="'История распределенных материалов/дел'")
    app-toolbar-item-period-short.ml-6(@select="loadPeriod") {{ periodDistributed ? periodDistributed.text : getToday }} 
    app-toolbar-item.ml-2(label="Судья" all="все" :items="judgesActive" key-name="lastName" min-width="140" @select="selectJudge" maxHeight="500px")
      | {{ selectedJudge ? selectedJudge.lastName : 'все'}}
    app-toolbar-item.ml-2(label="Тип распределения" all="все" :items="listDistribTypes" key-name="title" min-width="140" @select="selectType" maxHeight="500px")
      | {{ distribType ? distribType.title : 'все'}}

  .text-right
    v-chip.ma-2(v-if="search" color="#757575" text-color="white" small label close @click:close="search = null") Поиск:&nbsp;<b>{{ search }}</b>
    v-chip.ma-2(v-if="periodDistributed" color="#757575" text-color="white" small label close @click:close="setPeriodDistributed(null)") Период: <b>{{ periodDistributed.text  }}</b>
    v-chip.ma-2(v-if="selectedJudge" color="#757575" text-color="white" small label close @click:close="selectJudge(null)") Судья: <b>{{ selectedJudge.lastName  }}</b>
    v-chip.ma-2(v-if="distribType" color="#757575" text-color="white" small label close @click:close="selectType(null)") Тип распределения: <b>{{ distribType.title  }}</b>

  app-empty-list(v-if="cases.length == 0") Список пуст
  v-simple-table(v-else light :height="getHeightTable()" fixed-header)
    template(v-slot:default)
      thead
        tr
          th.text-left №
          th.text-left Номер дела
          th.text-left Категория/статья
          th.text-left История распределение
      tbody
        tr(v-for="(c, index) in cases" :key="c.id")
          td {{ index + 1 }}
          td {{ c.number }}
          td {{ c.caseCategory ? c.caseCategory.title : c.mainLawArticle ? c.mainLawArticle + ' УК РФ' : 'Категория не определена' }}
          td.text-left(width="300")
            v-layout.mt-2.mb-2(v-if="!c.judge") 
              v-flex(style="color:red") Не распределено
            v-layout.mt-2.mb-2(v-for="cd in c.caseDistributions" :key="cd.id")   
              v-flex(xs6) {{ cd.createDate ? $_formatRu(cd.createDate) : 'Нет' }}
              v-flex {{ cd.judge ? cd.judge.lastName : 'Не выбран' }}
              v-flex {{ cd.gas == 1 ? 'ГАС' : '' }}

</template>

<script>
import { $_app_moment } from "@/common/AppMoment.js"
import { mapGetters, mapMutations, mapState } from 'vuex'

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { Workbook } from 'exceljs'
var FileSaver = require('file-saver');

import moment from 'moment'
moment.locale('ru')

// es6
// import {json2excel, excel2json} from 'js2excel';




let typeDistrib = {
  PORTAL: 0,
  GAS: 1,
  HANDS: 2
}

export default {
  mixins: [ $_app_moment ],
  
  data () {
    return {
      search: null,
      distribType: null
    }
  },

  mounted () {
    this.$store.commit('setInJudgeReestr', true)
    this.$store.dispatch('judgeReestr/INIT_JUDGES')

    this.$store.commit('setInDistribution', true)
    this.$store.dispatch('distribution/LOAD_PERIOD_HISTORY')
  },

  computed: {
    ...mapState('distribution', ['periodDistributed', 'selectedJudge', 'today' ]),
    ...mapGetters('judgeReestr', ['judgesActive', 'isJudgesLoaded' ]),
    ...mapGetters('distribution', ['isDistribPeriod', 'distribPeriod' ]),

    loading () {
      return !this.isDistribPeriod
    },

    caseItems () {
      return [{ icon:'compare_arrows', title:'Передать судье', action: () => this.$refs.caseChangeJudge.show() }]
    },

    fabItems () {
      return [
        { icon:'add', title:'Сформировать PDF', action: () => this.distribGeneratePDF() },
        { icon:'add', title:'Сформировать XLS', action: () => this.distribGenerateXLS() },
      ]
    },

    listDistribTypes() {
      return [
        {title: "распределенные", value: typeDistrib.PORTAL},
        {title: "распределенные в ГАС", value: typeDistrib.GAS},
        {title: "распределенные вручную.", value: typeDistrib.HANDS},
      ]
    },

    cases () {
      let list = this.distribPeriod || []

      list = list.map(item => {
        if (item.caseDistributions)
          item.caseDistributions = item.caseDistributions.sort((a, b) => !b.createDate || b.createDate.localeCompare(a.createDate) || b.id - a.id)
        return item
      })

      if (this.distribType && this.distribType.value < 2) list = list.filter(item => item.caseDistributions.find(d => this.distribType.value == d.gas))
      if (this.distribType && this.distribType.value == 2) list = list.filter(item => item.caseDistributions.length > 1)
      if (this.selectedJudge) list = list.filter(c2 => c2.judge && c2.judge.id == this.selectedJudge.id)
      if (this.search) {
        list = [
          ...list.filter(item => item.number.toLowerCase().includes(this.search)),
          ...list.filter(item => item.caseCategory && item.caseCategory.title.toLowerCase().includes(this.search)),
          ...list.filter(item => item.mainLawArticle && item.mainLawArticle.toLowerCase().includes(this.search))
        ]
      }

      // return new Set(list)
      return list
    }
  },

  methods: {
    ...mapMutations('distribution', ['setPeriodDistributed', 'selectJudge', 'setDistribPeriod']),

    selectType (item) {
      this.distribType = item
    },

    getHeightTable() {
      if (this.cases.length > 5) return window.innerHeight - 200;
    },

    loadPeriod (period) {
      this.setPeriodDistributed(period)
      this.$store.dispatch('distribution/LOAD_PERIOD_HISTORY')
    },

    distribGeneratePDF () {
      let contentBody = [["№", "Номер дела", "Категория/статья", "История распределения"]]

      let index = 0
      this.cases.forEach(item => {
        let category = item.caseCategory ? item.caseCategory.title : item.mainLawArticle ? item.mainLawArticle + ' УК РФ' : 'Категория не определена'

        let contentTableBody = []
        if (!item.judge) 
          contentTableBody.push([{text: 'Не распределено', colSpan: 3}, {}, {}])

        let list = item.caseDistributions ? item.caseDistributions.sort((a, b) => !b.createDate || b.createDate.localeCompare(a.createDate) || b.id - a.id) : []
        if (list.length > 0)
          list.map(h => {
              contentTableBody.push([ h.createDate ? this.$_formatRu(h.createDate) : 'Нет', h.judge ? h.judge.lastName : 'Пусто', h.gas == 1 ? 'ГАС' : '' ])
          })

        let table = { table: { widths: [70, '*', '*'], body: contentTableBody }, layout: 'headerLineOnly' }

        let body = [[++index], [item.number], [category], [table]]
        contentBody.push(body)
      })

      let period = this.$_shortFormatRu(this.today)
      if (this.periodDistributed) {
        if (this.periodDistributed.start.indexOf(this.periodDistributed.end) != -1) period = this.$_shortFormatRu(this.periodDistributed.start)
        else period = "период " + this.$_shortFormatRu(this.periodDistributed.start) + " - " + this.$_shortFormatRu(this.periodDistributed.end)
      } 

      var contentPDF = {
        content: [
          {text: 'Список распределенных материалов/дел за ' + period, style: 'header'},
          { style: 'tableExample', table: { widths: [20, 80, '*', 170], body: contentBody }},
        ],
        styles: {
          header: { fontSize: 14,  bold: true, margin: [0, 0, 0, 10] },
          tableExample: { margin: [0, 5, 0, 15], fontSize: 9 }
        }
      }

      pdfMake.createPdf(contentPDF).open()
    },

    distribGenerateXLS () {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet("My Sheet");

      worksheet.columns = [
        {header: 'Номер дела',          key: 'number',    width: 25},
        {header: 'Категория/статья',    key: 'category',  width: 50}, 
        {header: 'Дата распределения',  key: 'date',      width: 20},
        {header: 'Судья',               key: 'judge',     width: 20},
        {header: 'ГАС',                 key: 'gas',       width: 5}
      ];

      let cells = ['A', 'B', 'C', 'D', 'E']
      cells.map(cell => { worksheet.getCell(cell + 1).font = {bold: true} })

      this.cases.forEach(item => {
        let category = item.caseCategory ? item.caseCategory.title : item.mainLawArticle ? item.mainLawArticle + ' УК РФ' : 'Категория не определена'

        let list = item.caseDistributions ? item.caseDistributions.sort((a, b) => !b.createDate || b.createDate.localeCompare(a.createDate) || b.id - a.id) : []
        let start = worksheet._rows.length + 1
        list.map((h, index) => {
          worksheet.addRow({
            number: index == 0 ? item.number : '', 
            category: index == 0 ? category : '', 
            date: h.createDate ? this.$_formatRu(h.createDate) : '-',
            judge: h.judge ? h.judge.lastName : '-',
            gas: h.gas == 1 ? 'ГАС' : '-' 
          })
        })

        cells.map(cell => {
          if (cell.indexOf("B") != -1) worksheet.getCell(cell + start).alignment = { wrapText: true };
          else worksheet.getCell(cell + start).alignment = { vertical: 'middle', horizontal: 'left' };
        })

        if (list.length > 1) {
          let end = worksheet._rows.length
          worksheet.mergeCells('A' + start + ':A' + end)
          worksheet.mergeCells('B' + start + ':B' + end)
        }
      })

      let period = this.$_shortFormatRu(this.today)
      if (this.periodDistributed) {
        if (this.periodDistributed.start.indexOf(this.periodDistributed.end) != -1) period = "за " + this.$_shortFormatRu(this.periodDistributed.start)
        else period = "с " + this.$_shortFormatRu(this.periodDistributed.start) + " по " + this.$_shortFormatRu(this.periodDistributed.end)
      } 

      workbook.xlsx.writeBuffer()
      .then(buffer => FileSaver.saveAs(new Blob([buffer]), 'История распределения ' + period + '.xlsx'))
      .catch(err => console.log('Error writing excel export', err))
    }
    
  },
  beforeDestroy() {
    this.$store.commit('setInJudgeReestr', false)
    this.$store.commit('setInDistribution', false)
  }
}

</script>